import React from 'react';
import {
  IconCertificate,
  IconArrowsUpDown,
  IconSchool,
  IconCurrencyRupee,
} from '@tabler/icons-react';

const benefits = [
  {
    IconComponent: IconCertificate,
    feature: 'Compliance',
    benefit:
      'We handle PF, ESI, Labor Law compliance, and insurance — fully taken care of so you never miss a deadline.',
  },
  {
    IconComponent: IconArrowsUpDown,
    feature: 'Scalability',
    benefit:
      'Quickly increase or decrease staff strength based on seasonal needs, project demands, or sudden changes.',
  },
  {
    IconComponent: IconSchool,
    feature: 'Training',
    benefit:
      'Staff arrive pre-trained in required skills, equipment handling, and protocols — ready from day one.',
  },
  {
    IconComponent: IconCurrencyRupee,
    feature: 'Cost Control',
    benefit:
      'Replace fixed payroll costs with a flexible variable service fee, often significantly reducing overhead.',
  },
];

const OutsourcingBenefitsTable = () => (
  <section className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
    <div className="max-w-[75rem] mx-auto">
      <div className="text-center mb-10 sm:mb-12">
        <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase tracking-widest mb-3">
          WHY OUTSOURCE
        </h2>
        <h3
          style={{ lineHeight: 1.25 }}
          className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-4xl font-bold"
        >
          Benefits of Outsourcing Manpower to Us
        </h3>
        <p className="text-[#6D7E94] text-sm sm:text-base font-[500] mt-4 max-w-xl mx-auto leading-relaxed">
          Outsourcing your facility and security manpower means lower costs, zero compliance
          headaches, and a team that is always ready to scale with your business.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {benefits.map(({ IconComponent, feature, benefit }, i) => (
          <div
            key={i}
            className="bg-[rgba(255,244,248,1)] rounded-2xl p-6 flex flex-col gap-4"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl shadow-sm">
              <IconComponent size={24} className="text-[#966376]" stroke={1.5} />
            </div>
            <h4 className="text-[#0B2549] font-sans font-semibold text-base">{feature}</h4>
            <p className="text-[#6D7E94] text-sm leading-relaxed">{benefit}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default OutsourcingBenefitsTable;
